module.exports = __webpack_public_path__ + "img/icon_closed.875a6be5.svg";